export default __webpack_public_path__ + "static/media/eletrico-large.90fcc7be.jpg";